module.exports = __webpack_public_path__ + "assets/img/AstonRX-Landing-Page.4a778187.jpg";